"use client"

import errorMap from "@/error-map";
import {z} from "zod";

z.setErrorMap(errorMap)
export default function ZodErroMapDe() {
  return <></>
}
